import { render, staticRenderFns } from "./CategoryStack.vue?vue&type=template&id=483eeaf2&scoped=true&"
import script from "./CategoryStack.vue?vue&type=script&lang=js&"
export * from "./CategoryStack.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStack.vue?vue&type=style&index=0&id=483eeaf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483eeaf2",
  null
  
)

export default component.exports